// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"bfab584c","160":"627d40c6","208":"bcd560cf","293":"d26f7ca1","516":"934c2c35","519":"fbf51bb6","917":"62b13c67","946":"efac144e"}[chunkId] + ".chunk.js";
};